<template>
	<div class="h-full">
		<TopAppBar
				:leftBtnMode="leftBtnMode"
				:rightBtnMode="rightBtnMode"
				:title="title"
				:leftBtnMethod="leftBtnMethod"
				:rightBtnMethod="rightBtnMethod"
        :hideCategory="false"
				staticMode="true"
				>
		</TopAppBar>
		<div class="d-flex h-full flex-column bg-documentGray h-full">
			<TopAppBarDrawer></TopAppBarDrawer>
		<main class="main-wrapper flex-grow-1">
			<div class="d-flex align-items-center bg-white">
				<div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center">
					{{this.$t('1289')}}
				</div>
				<!-- <div class="mgr-24 right-button"><button class="mdc-icon-button"><i
							class="material-icons t-headline6 ">search</i></button>
				</div> -->
			</div>
			<div class="divider"></div>

			<div class="container container--narrow pdt-30">
				<div class="mdc-card">
					<div class="d-flex leader-list pda-24 cursor-pointer" @click="info" @keypress="info" tabindex="0">
						<div class="mgr-16">
							<div v-if="profileImage"
									class="w-40 h-40 t-headline7 iconHolder min-w-40 t-color-white font-r d-flex justify-content-center align-items-center"
							>
									<UserImgProfile :data="personalInfo" :size="'s'" :className="'mgr-0'" />
							</div>
							<div v-else v-html="firstCharOfNames" :style="bgColorOfName" class="min-w-40 h-40 user-name-profile"></div>
							<!-- <div v-else>
									<img src="images/ic_account.png" alt class="w-40 h-40" />
							</div> -->
						</div>
						<div class="d-flex align-items-center justify-content-between flex-grow-1">
							<div class="flex-grow-1 pdr-16">
								<div class="t-body1 font-r l-spacing48 t-line-h-22">{{ (personalInfo && personalInfo.name)? $t('3437',{first: personalInfo.name.first, last: personalInfo.name.last}):''}}</div>
								<div class="t-helper font-r t-color-bodyGrayA">{{ personalInfo ? personalInfo.userId: '' }}</div>
							</div>
							<button class="mdc-icon-button material-icons s-icon t-color-bodyGrayA rtl-support"
								title="">chevron_right</button>
						</div>

					</div>
				</div>

				<div class="mdc-card pdt-8 pdb-8 mgt-24">
					<div class="setting-list">
						<!-- <div class="d-flex setting-list-item pdt-12 pdb-12 pdr-24 pdl-24">
							<div class="pdt-4 mgr-32">
								<i class="material-icons t-color-iconInactive rtl-support">notifications_none</i>
							</div>
							<div class="d-flex align-items-center justify-content-between flex-grow-1">
								<div class="flex-grow-1 pdr-16">
									<div class="t-body1 font-r l-spacing48">알림 수신 여부</div>
								</div>
								<div>
									<div class="mdc-switch " data-mdc-auto-init="MDCSwitch">
										<div class="mdc-switch__track"></div>
										<div class="mdc-switch__thumb-underlay">
											<div class="mdc-switch__thumb"></div>
											<input type="checkbox" id="another-basic-switch"
												class="mdc-switch__native-control" role="switch" aria-checked="true">
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="d-flex setting-list-item pdt-12 pdb-12 pdr-24 pdl-24">
							<div class="pdt-4 mgr-32">
								<i class="material-icons t-color-iconInactive rtl-support"><img src="images/seal.svg" alt=""
										class="pdl-2"></i>
							</div>
							<div class="d-flex align-items-center justify-content-between flex-grow-1">
								<div class="flex-grow-1 pdr-16">
									<div class="t-body1 font-r l-spacing48">오픈 배지 사용</div>
								</div>
								<div>
									<div class="mdc-switch" data-mdc-auto-init="MDCSwitch">
										<div class="mdc-switch__track"></div>
										<div class="mdc-switch__thumb-underlay">
											<div class="mdc-switch__thumb"></div>
											<input type="checkbox" id="another-basic-switch"
												class="mdc-switch__native-control" role="switch" aria-checked="true">
										</div>
									</div>
								</div>
							</div>
						</div> -->

						<!-- 차단 사용자 관리 -->
						<div class="d-flex setting-list-item pdt-12 pdb-12 pdr-24 pdl-24 cursor-pointer" @click="block" @keypress="block"  tabindex="0">
							<div class="pdt-4 mgr-32">
								<i class="material-icons t-color-iconInactive rtl-support">block</i>
							</div>
							<div class="d-flex align-items-center justify-content-between flex-grow-1">
								{{ $t('3824') }}
							</div>
							<div class="d-flex align-items-center">
								<button
									class="mdc-icon-button material-icons s-icon mgl--12 t-color-bodyGrayA rtl-support"
									title="">chevron_right</button>
							</div>
						</div>
						<div class="divider"></div>

						<div class="d-flex setting-list-item pdt-12 pdb-12 pdr-24 pdl-24 cursor-pointer" @click="privacy" @keypress="privacy" tabindex="0">
							<div class="pdt-4 mgr-32">
								<i class="material-icons t-color-iconInactive rtl-support">security</i>
							</div>
							<div class="d-flex align-items-center justify-content-between flex-grow-1">
								<div class="flex-grow-1 pdr-16">
									<div class="t-body1 font-r l-spacing48">{{ $t('1292') }}</div>
								</div>
								<div class="d-flex align-items-center">
									<button
										class="mdc-icon-button material-icons s-icon mgl--12 t-color-bodyGrayA rtl-support"
										title="">chevron_right</button>
								</div>
							</div>
						</div>
						<div class="divider"></div>
						<div class="d-flex setting-list-item pdt-12 pdb-12 pdr-24 pdl-24 cursor-pointer"  @click="terms" @keypress="terms" tabindex="0">
							<div class="pdt-4 mgr-32">
								<i class="material-icons t-color-iconInactive rtl-support">
									<img src="/images/terms-check.svg" alt="" class="pdl-2 w-24 h-24">
								</i>
							</div>
							<div class="d-flex align-items-center justify-content-between flex-grow-1">
								<div class="flex-grow-1 pdr-16">
									<div class="t-body1 font-r l-spacing48">{{ $t('1293') }}</div>
								</div>
								<div class="d-flex align-items-center">
									<button
										class="mdc-icon-button material-icons s-icon mgl--12 t-color-bodyGrayA rtl-support"
										title="">chevron_right</button>
								</div>
							</div>
						</div>
						<div class="divider"></div>
						<div class="d-flex setting-list-item pdt-12 pdb-12 pdr-24 pdl-24 cursor-pointer" @click="lang" @keypress="lang" tabindex="0">
							<div class="pdt-4 mgr-32">
								<i class="material-icons t-color-iconInactive rtl-support">public</i>
							</div>
							<div class="d-flex align-items-center justify-content-between flex-grow-1">
								<div class="flex-grow-1 pdr-16">
									<div class="t-body1 font-r l-spacing48">{{ $t('1294') }}</div>
								</div>
								<div class="d-flex align-items-center">
									<button
										class="mdc-icon-button material-icons s-icon mgl--12 t-color-bodyGrayA rtl-support"
										title="">chevron_right</button>
								</div>
							</div>
						</div>
						<div class="divider"></div>
						<!-- <div class="d-flex setting-list-item pdt-12 pdb-12 pdr-24 pdl-24">
							<div class="pdt-4 mgr-32">
								<i class="material-icons t-color-iconInactive rtl-support">accessibility</i>
							</div>
							<div class="d-flex align-items-center justify-content-between flex-grow-1">
								<div class="flex-grow-1 pdr-16">
									<div class="t-body1 font-r l-spacing48">어플리케이션 접근 권한</div>
								</div>
								<div class="d-flex align-items-center">
									<button
										class="mdc-icon-button material-icons s-icon mgl--12 t-color-bodyGrayA rtl-support"
										title="">chevron_right</button>
								</div>
							</div>
						</div>
						<div class="d-flex setting-list-item pdt-12 pdb-12 pdr-24 pdl-24">
							<div class="pdt-4 mgr-32">
								<i class="material-icons t-color-iconInactive rtl-support">cloud_queue</i>
							</div>
							<div class="d-flex align-items-center justify-content-between flex-grow-1">
								<div class="flex-grow-1 pdr-16">
									<div class="t-body1 font-r l-spacing48">어플리케이션 버전</div>
								</div>
								<div class="d-flex align-items-center">
									<button
										class="mdc-icon-button material-icons s-icon mgl--12 t-color-bodyGrayA rtl-support"
										title="">chevron_right</button>
								</div>
							</div>
						</div> -->
						<div class="d-flex setting-list-item pdt-12 pdb-12 pdr-24 pdl-24 cursor-pointer" @click.prevent="deleteCache" @keypress.prevent="deleteCache" tabindex="0">
							<div class="pdt-4 mgr-32">
								<i class="material-icons t-color-iconInactive rtl-support">build</i>
							</div>
							<div class="d-flex align-items-center justify-content-between flex-grow-1">
								<div class="flex-grow-1 pdr-16">
									<div class="t-body1 font-r l-spacing48">{{ $t('1297') }}</div>
								</div>
								<div class="d-flex align-items-center">
									<div class="t-body3 t-color-iconInactive font-rn mgr-4">{{total}}</div>
									<button
										class="mdc-icon-button material-icons s-icon t-color-bodyGrayA rtl-support"
										title="">chevron_right</button>
								</div>
							</div>
						</div>

					</div>
				</div>




			</div>
			<div class="mdc-snackbar footer" id="snackbar1">
				<div class="mdc-snackbar__surface">
					<div class="mdc-snackbar__label t-color-whiteHigh t-body3 font-r l-spacing42" role="status"
						aria-live="polite">
						캐시 데이터가 삭제되었습니다.
					</div>
					<!-- <div class="mdc-snackbar__actions"><button type="button" class="mdc-button mdc-snackbar__action">
							<div class="mdc-button__ripple"></div>
							<div class="mdc-button__label t-color-secondaryBtnText">확인</div>
						</button>
					</div> -->
				</div>
			</div>
		</main>
		</div>
	</div>
</template>

<script>
// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue'
import { topAppBarMixin } from "../../mixins/topAppBar.js";
import httpService from '@/api/httpService.js'
import memberApi from '@/api/memberApi.js'
import TopAppBarDrawer from '@/components/TopAppBarDrawer.vue'

export default {
	data() {
		return {
			CACHE_SIZE: 64,
			notiStatus: false,
			badgeStatus: true,
			personalInfo: null,
			profileImage: null,
			total: 0,
			firstCharOfNames: localStorage.getItem('firstChar'),
			bgColorOfName: localStorage.getItem('bgColors'),
		};
	},

	components: {
		TopAppBar,
		TopAppBarDrawer,
		UserImgProfile: () => import("@/components/common/checkUser/UserImgProfile.vue"),
	 },

	mixins: [topAppBarMixin],
	mounted() {
			this.fatchData()
			var _lsTotal = 0,
			_xLen,
			_x;
		for (_x in localStorage) {
			if (!localStorage.hasOwnProperty(_x)) {
				continue;
			}
			_xLen = (localStorage[_x].length + _x.length) * 2;
			_lsTotal += _xLen;
		}
		this.total = (_lsTotal / 1024).toFixed(2) + " KB";
		this.setTopAppBarHomeSearch(localStorage.getItem('brandName'));
  },

	methods:{
		fatchData() {
			memberApi.getMemberInfo().then((response)=>{
					this.personalInfo = response.data.data
					this.profileImage = this.personalInfo? this.personalInfo.profile:''
			})
		},
		goToBack() {
			this.$router.push({
				name: "Main",
			})
		},
		block() {
			this.$router.push({
				name: "BlockUser"
			})
		},
		privacy() {
			this.$router.push("privacy");
		},
		terms() {
			this.$router.push("terms");
		},
		lang() {
			this.$router.push("languages");
		},
		access() {
			this.$router.push("access-right");
		},
		appversion() {
			this.$router.push("app-version");
		},
		info() {
			localStorage.setItem("goToSetting", "setting");
			this.$router.push("member/myinfo");
		},
    deleteCache(){
      for (var i = 0; i < localStorage.length; ++i) {
        if (localStorage.key(i) !== 'VUE_APP_API_HOST' && localStorage.key(i) !== 'VUE_APP_PAYMENT_HOST') {
          localStorage.removeItem(localStorage.key(i));
        }
      }
			// localStorage.clear();
			this.total = '';
			this.$snackOpen({contents: this.$t('1940'), btnDisplayYN: false}).then(() => {})
		}
	}
};
</script>


<style scoped>
.shadow {
	-webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
		0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
	box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
		0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
}

.toggle-size {
	font-size: 2.5rem;
}

.link-color {
		color: var(--Primary);
}

.border-bottom {
	border-bottom: 1px solid var(--Divider);
}

.active-checked {
	color: #212121;
}
.cursor-pointer {
	cursor: pointer;
}
.iconHolder {
	border-radius: 50%;
}
</style>
